import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="Weitere Erfahrungsberichte" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-111" data-mp="20fowudtw93h2">
      <h2 className="text-center font-display text-2xl font-black text-grape sm:text-3xl" data-id="element-112" data-mp="25auqjytjfmfp">
        💙 Weitere Profis, die den Reha-Code 360° bereits anwenden
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-113" data-mp="1clnjgbg0poiu">
        {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i % 2 * 0.1} data-id="element-114" data-mp="1hjfnu4xun33x" data-mpi={i} />)}
      </div>
    </section>;
}